import React from 'react';
import { Create as CreateIcon, Save as SaveIcon } from '@mui/icons-material';
import { defineMessages, useIntl } from 'react-intl';
import TooltipButton from './TooltipButton';
const msgs = defineMessages({
    buttonEdit: {
        id: 'button.EditButton.button.edit',
        defaultMessage: 'Edit',
    },
    buttonSaveChange: {
        id: 'button.EditButton.button.saveChange',
        defaultMessage: 'Save Change',
    },
});
const EditButton = ({ locked, onEdit, onSave, ...props }) => {
    const intl = useIntl();
    return (React.createElement(TooltipButton, { message: intl.formatMessage(locked ? msgs.buttonEdit : msgs.buttonSaveChange), icon: locked ? React.createElement(CreateIcon, { fontSize: "small" }) : React.createElement(SaveIcon, { fontSize: "small" }), onClick: locked ? onEdit : onSave, ...props }));
};
export default EditButton;
